import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("gf_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("gf_token");
    if (!token) { setLoading(false); return; }
    api.get("/api/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("gf_user", JSON.stringify(r.data)); })
      .catch(() => { localStorage.removeItem("gf_token"); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/api/auth/login", { email, password });
    localStorage.setItem("gf_token", data.token);
    localStorage.setItem("gf_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const signup = async (payload) => {
    const { data } = await api.post("/api/auth/signup", payload);
    localStorage.setItem("gf_token", data.token);
    localStorage.setItem("gf_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("gf_token");
    localStorage.removeItem("gf_user");
    setUser(null);
  };

  const refresh = async () => {
    const { data } = await api.get("/api/auth/me");
    setUser(data);
    localStorage.setItem("gf_user", JSON.stringify(data));
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() { return useContext(AuthCtx); }
